import React from "react";
import { Button } from "react-bootstrap";

// Interact with a whitelisted contract
// Lockbox instance (this.state.lockbox) is passed into to props as props.lockbox
// Address of sender (this.state.address) is passed into props as props.address
// List of whitelisted app names (this.state.whitelistNames) is passed into props as props.whitelistNames
function WhitelistActionsTab(props) {

    const handleWhitelist = (event) => {
        event.preventDefault();
        submitWhitelist(event.target.protocol.value, event.target.wAmount.value);
    }

    const submitWhitelist = async (protocol, amount) => {
        if (protocol == "GiveDirectly") {
            let res = await props.lockbox.methods.GiveDirectlyWhitelistInteraction(true).send({ from: props.address });
            console.log(res)
        } else if (protocol == "RiskyInvestment") {
            if (amount >= 0) {
                let res = await props.lockbox.methods.RiskyInvestmentWhitelistInteraction(true).send({ from: props.lockboxAddress });
                console.log(res)
            } else {
                let res = await props.lockbox.methods.RiskyInvestmentWhitelistInteraction(false).send({ from: props.address });
                console.log(res)
            }
        }
    }

    return (
        <form onSubmit={handleWhitelist}>
            <label>You are whitelisted for: {props.whitelistNames.toString()}</label>
            <br />
            <label>Enter whitelisted protocol name</label>
            <br />
            <input type="text" name="protocol" className="form-control w-25 center-block"></input>
            <br />
            <label>Enter amount to send to protocol</label>
            <br />
            <input type="number" name="wAmount" className="form-control w-25 center-block"></input>
            <br />
            <br />
            <Button variant="dark" type="submit">Submit Whitelist Action</Button>
        </form>
    )
}

export default WhitelistActionsTab
